"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveCalendarCms = void 0;
var LiveCalendarCms = /** @class */ (function () {
    function LiveCalendarCms() {
        this.arrivalWindowLabel = "Technician's arrival window";
        this.dateLabel = 'Date';
        this.tooltipText = "Your technician's arrival time is flexible.\n\n  The time ranges listed reflect the technician's arrival window\n   and not the length of the installation. Depending on services ordered,\n    a standard installation takes an average of 4 hours from the time your technician arrives.";
        this.tooltipTextDirectv = "Some optional features and apps on our DIRECTV receivers will\n  require an internet connection. Your installer will need this connection to ensure all\n  the features are up and running correctly.";
        this.selectDateLabel = "Select date";
        this.selectTimeLabel = "Select time";
        this.appointmentPreference = 'Appointment preference';
        this.tooltipTextSMB = "<strong> Your technician\u2019s arrival time may vary. </strong>\n  <br />The time ranges listed reflect the technician\u2019s arrival timeframe and not\n  the length of the installation. Depending on the services you ordered, a standard installation\n  takes an average of 4 hours from the time your technician arrives.\u201D";
    }
    return LiveCalendarCms;
}());
exports.LiveCalendarCms = LiveCalendarCms;
//# sourceMappingURL=LiveCalendar.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/InstallationCard/LiveCalendar/LiveCalendar.cms.js
// module id = 958
// module chunks = 8